import { Loader } from "@googlemaps/js-api-loader";

function createMarker(map, location) {
    const content = document.createElement("div");
    content.classList.add("property");
    content.innerHTML = `
        <div class="icon">
            <img src="/build/elite-cricket-training/svg/icon-map-marker.svg" style="width: 70px; height: 70px;" alt="Elite Cricket Training"/>
        </div>
    `;

    const marker = new google.maps.marker.AdvancedMarkerElement({
        map,
        position: location,
        title: 'Elite Cricket Training',
        content: content,
    });

    const lat = location.lat();
    const lng = location.lng();
    const directionsLink = `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}`;

    const contentString = `
        <div class="flex flex-col gap-1 pl-2 pr-1 py-1">
            <p class="text-sm uppercase font-medium text-blue-midnight">
                Elite Cricket Training
            </p>
            <a href="${directionsLink}" target="_blank" rel="nofollow noopener" class="uppercase text-orange-sunset text-xs font-medium flex items-center justify-start gap-1">
                <svg viewBox="0 0 16 16" class="pointer-events-none w-4 h-4">
                    <g>
                        <path fill="#bb802c" d="M8,15c-3.86,0-7-3.141-7-7c0-3.86,3.14-7,7-7c3.859,0,7,3.14,7,7C15,11.859,11.859,15,8,15z M8,2C4.691,2,2,4.691,2,8   s2.691,6,6,6s6-2.691,6-6S11.309,2,8,2z"></path>
                        <path fill="#bb802c" d="M8,13c-0.021,0-0.042-0.001-0.064-0.004c-0.226-0.029-0.404-0.208-0.432-0.434L7.052,8.948L3.438,8.496   C3.212,8.468,3.033,8.29,3.004,8.063C2.975,7.838,3.103,7.621,3.314,7.536l7.5-3c0.184-0.074,0.397-0.031,0.539,0.111   c0.142,0.142,0.185,0.354,0.11,0.539l-3,7.5C8.388,12.877,8.202,13,8,13z M5.485,7.744l2.077,0.26   c0.227,0.028,0.406,0.207,0.434,0.434l0.26,2.077l1.847-4.617L5.485,7.744z"></path>
                    </g>
                </svg>
                <span class="pointer-events-none">Get Directions</span>
            </a>
        </div>
    `;

    const infoWindow = new google.maps.InfoWindow({
        content: contentString
    });

    infoWindow.open(map, marker);

    marker.addListener('click', () => {
        infoWindow.open(map, marker);
    });
}

window.addEventListener('load', () => {
    const googleMapsLoader = new Loader({
        apiKey: window.eliteCricket.mapsKey,
        version: "weekly",
        libraries: ["places", "marker"]
    });

    document.querySelectorAll('.google-map-container').forEach((mapContainer, mapIndex) => {
        const googleMapsOpts = (google, centre = null) => {
            return {
                mapId: window.eliteCricket.mapId,
                zoom: 14,
                center: centre ? centre : new google.maps.LatLng(-32.039, 115.843),
                mapTypeControl: false,
                panControl: false,
                scaleControl: false,
                zoomControl: true,
                zoomControlOptions: {
                    style: google.maps.ZoomControlStyle.LARGE,
                    position: google.maps.ControlPosition.LEFT_BOTTOM
                },
                streetViewControl: true,
                streetViewControlOptions: {
                    position: google.maps.ControlPosition.LEFT_BOTTOM
                }
            };
        };

        googleMapsLoader
            .load()
            .then((google) => {

                const initFunc = (loc) => {
                    const googleMap = new google.maps.Map(mapContainer, googleMapsOpts(google, loc));

                    if (loc) {
                        createMarker(googleMap, loc)
                    }
                };

                if (window?.eliteCricket?.streetAddress) {
                    const geocoder = new google.maps.Geocoder();
                    return geocoder.geocode({ 'address': window.eliteCricket.streetAddress }, function (results, status) {
                        let loc = null;

                        if (status === google.maps.GeocoderStatus.OK) {
                            loc = results[0].geometry.location;
                        }

                        return initFunc(loc);
                    });
                }

                return initFunc(null);
            });
    });
});